import React from 'react';

const Pagination = ({ filters, filters: { page } = {}, count, onChange = () => {} }) => {

  const totalPages = Math.ceil(count / 10);

  const generatePageNumbers = () => {
    const pageIndex = page - 1;
    const visiblePageCount = 3;

    if (totalPages <= visiblePageCount) {
      // Return all page numbers if there are 3 or fewer pages
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    const pageNumbers = [];

    if (pageIndex === 0 || pageIndex === 1) {
      pageNumbers.push(1, 2, 3);
    } else if (pageIndex === totalPages - 1) {
      pageNumbers.push(totalPages - 2, totalPages - 1, totalPages);
    } else {
      pageNumbers.push(pageIndex, pageIndex + 1, pageIndex + 2);
    }

    return pageNumbers;
  };

  return (
    <div className="h-2">
      {
        <div className="table-pagination">
          <div className={`navigate ${page <= 1 ? 'disabled' : ''}`} onClick={() => onChange({...filters, page: 1})}>
            {'First'}
          </div>

          <div className='divider'></div>

          {generatePageNumbers().map((pageNumber) => (
            <React.Fragment key={pageNumber}>
              <div
                onClick={() => page !== pageNumber && onChange({...filters, page: pageNumber})}
                className={page === pageNumber ? 'navigate active disabled' : 'navigate'}
              >
                {pageNumber}
              </div>
              <div className="divider"></div>
            </React.Fragment>
          ))}

          <div className={`navigate ${page < totalPages ? '' : 'disabled'}`} onClick={() => page < totalPages && onChange({...filters, page: totalPages })}>
            {'Last'}
          </div>
        </div>
      }
    </div>
  );
};

export default Pagination;
